import * as React from 'react';

function SvgIcButtonMyInvoices(props) {
  return (
    <svg
      id="ic_my_invoices_svg__img_"
      width={90.689}
      height={90.689}
      viewBox="0 0 90.689 90.689"
      xmlSpace="preserve"
      {...props}
    >
      <defs>
        <linearGradient
          id="ic_button_my_invoices_svg__a"
          x1={-0.092}
          y1={-0.109}
          x2={1.087}
          y2={1.231}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#710cd6" />
          <stop offset={1} stopColor="#ff2658" />
        </linearGradient>
      </defs>
      <g data-name="Group 742">
        <path
          data-name="Path 373"
          d="M3.652 0h87.037v90.689H0V0z"
          fill="url(#ic_button_my_invoices_svg__a)"
        />
        <g data-name="Group 708">
          <g data-name="Group 707">
            <path
              data-name="Path 735"
              d="M70.525 28.684h-7.789v-7.789A3.9 3.9 0 0058.841 17H23.789a3.9 3.9 0 00-3.894 3.895v46.736h-2.921A.974.974 0 0016 68.6v1.947a3.9 3.9 0 003.895 3.895H53a3.9 3.9 0 003.895-3.895V59.841h7.789a3.9 3.9 0 003.895-3.895v-8.762h4.868a.974.974 0 00.974-.974V32.579a3.9 3.9 0 00-3.896-3.895zM19.895 72.5a1.947 1.947 0 01-1.947-1.947v-.974H49.1v.974a3.865 3.865 0 00.523 1.947zm35.052-51.6v49.652a1.948 1.948 0 01-3.895 0V68.6a.974.974 0 00-.974-.974H21.842V20.895a1.947 1.947 0 011.947-1.948h31.7a3.855 3.855 0 00-.542 1.948zm1.947 37v-37a1.948 1.948 0 013.895 0v35.047a3.855 3.855 0 00.541 1.947zm9.737-25.315v23.362a1.948 1.948 0 11-3.895 0V30.631h4.436a3.855 3.855 0 00-.541 1.948zm5.842 12.658h-3.895V32.579a1.948 1.948 0 113.895 0z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Group 710">
          <g data-name="Group 709">
            <path
              data-name="Rectangle 227"
              fill="#fff"
              d="M25.489 42.446h22v2h-22z"
            />
          </g>
        </g>
        <g data-name="Group 712">
          <g data-name="Group 711">
            <path
              data-name="Rectangle 228"
              fill="#fff"
              d="M31.489 39.446h21v2h-21z"
            />
          </g>
        </g>
        <g data-name="Group 714">
          <g data-name="Group 713">
            <path
              data-name="Path 736"
              d="M41.19 29.942a2.769 2.769 0 00-1.411-1.657l-1.9-.949a.832.832 0 01.371-1.575h.284a.832.832 0 01.831.832v.142h1.947v-.142a2.774 2.774 0 00-1.947-2.638v-1.113h-1.947v1.115a2.769 2.769 0 00-.411 5.123l1.9.949a.832.832 0 01-.371 1.575h-.284a.832.832 0 01-.832-.832v-.142h-1.946v.142a2.774 2.774 0 001.947 2.638v1.115h1.947v-1.114a2.769 2.769 0 001.822-3.469z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Group 716">
          <g data-name="Group 715">
            <path
              data-name="Rectangle 229"
              fill="#fff"
              d="M28.489 39.446h1v2h-1z"
            />
          </g>
        </g>
        <g data-name="Group 718">
          <g data-name="Group 717">
            <path
              data-name="Rectangle 230"
              fill="#fff"
              d="M25.489 52.446h22v1h-22z"
            />
          </g>
        </g>
        <g data-name="Group 720">
          <g data-name="Group 719">
            <path
              data-name="Rectangle 231"
              fill="#fff"
              d="M31.489 47.447h21v3h-21z"
            />
          </g>
        </g>
        <g data-name="Group 722">
          <g data-name="Group 721">
            <path
              data-name="Rectangle 232"
              fill="#fff"
              d="M28.489 47.447h1v3h-1z"
            />
          </g>
        </g>
        <g data-name="Group 724">
          <g data-name="Group 723">
            <path
              data-name="Rectangle 233"
              fill="#fff"
              d="M25.489 61.446h22v1h-22z"
            />
          </g>
        </g>
        <g data-name="Group 726">
          <g data-name="Group 725">
            <path
              data-name="Rectangle 234"
              fill="#fff"
              d="M31.489 57.446h21v1h-21z"
            />
          </g>
        </g>
        <g data-name="Group 728">
          <g data-name="Group 727">
            <path
              data-name="Rectangle 235"
              fill="#fff"
              d="M28.489 57.446h1v1h-1z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgIcButtonMyInvoices;
